import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./CrmFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import CrmFormStepOne from "./CrmFormSteps/CrmFormStepOne";

import CrmFormStepDescription from "./CrmFormSteps/CrmFormStepDescription";
import CrmFormStepParticipants from "./CrmFormSteps/CrmFormStepParticipants";
import CrmFormEventStepOne from "./CrmEvents/CrmFormEventStep/CrmFormEventStepOne";

const CrmForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
        ..._initialValues,
        clientType: _initialValues?.clientType
          ? { value: _initialValues?.clientType }
          : null,

        clientOrigin: _initialValues?.clientOrigin?.uuid
          ? { value: _initialValues?.clientOrigin?.uuid }
          : null,
        processGoal: _initialValues?.processGoal?.uuid
          ? { value: _initialValues?.processGoal?.uuid }
          : null,
        prognosis: _initialValues?.prognosis?.uuid
          ? { value: _initialValues?.prognosis?.uuid }
          : null,
        acquisitionSource: _initialValues?.acquisitionSource?.uuid
          ? { value: _initialValues?.acquisitionSource?.uuid }
          : null,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, { ...props, initialValues })}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <>
            {!update ? (
              <form
                id={props.formName}
                onSubmit={formProps.handleSubmit}
                className="CrmForm"
              >
                <SwipeableViews
                  axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                  index={step}
                  onChangeIndex={(index) => setStep(index)}
                >
                  <CrmFormStepOne {...formProps} {...props} />
                  <CrmFormEventStepOne {...formProps} {...props} />
                </SwipeableViews>
              </form>
            ) : (
              <form
                id={props.formName}
                onSubmit={formProps.handleSubmit}
                className="CrmForm"
              >
                <SwipeableViews
                  axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                  index={step}
                  onChangeIndex={(index) => setStep(index)}
                >
                  <CrmFormStepOne {...formProps} {...props} />
                  <CrmFormStepDescription {...formProps} {...props} />
                  <CrmFormStepParticipants {...formProps} {...props} />
                </SwipeableViews>
              </form>
            )}
          </>
        );
      }}
    </Form>
  );
};

export default CrmForm;
